import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import ClientList from "src/components/Planner/Client/Client-list";

// ----------------------------------------------------------------------

export default function PlannerClients() {
  return (
    <>
      <Helmet>
        <title> Clients </title>
      </Helmet>

      <Container maxWidth="xl">
        <ClientList />
      </Container>
    </>
  );
}
